import PageContainer from '../components/common/PageContainer';
import * as uiLayout from '../components/common/uiLayout';
import './rtl-forms-fix.css';
import { DESKTOP_BREAKPOINT, navigationContentSx } from '../config/sidebarLayout';
import NavigationShell from '../components/NavigationShell';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  GlobalStyles,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import BadgeIcon from "@mui/icons-material/Badge";
import CloseIcon from "@mui/icons-material/Close";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import SecurityIcon from "@mui/icons-material/Security";
import SelectAllIcon from "@mui/icons-material/SelectAll";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import PermissionPackagesDialog from "../components/userManagement/PermissionPackagesDialog";
import BulkPermissionsDialog from "../components/userManagement/BulkPermissionsDialog";
import GroupsIcon from "@mui/icons-material/Groups";
import DesktopAccessDialog from "../components/userManagement/DesktopAccessDialog";
import DesktopAccessDisabledIcon from "@mui/icons-material/DesktopAccessDisabled";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import UserDocumentsTab from "../components/userManagement/UserDocumentsTab";

import Swal from "sweetalert2";
import { SSTLI_API_URL } from "../config/apiUrls";
import { getNickname, saveNickname, useNicknames, withNickname } from "../utils/nicknames";




const API_BASE_URL =
  SSTLI_API_URL;




const primary = "#057546";
const primaryDark = "#034d31";
const border = "#dce8e2";
const soft = "#f7fbf9";
const ZERO_GUID = "00000000-0000-0000-0000-000000000000";

const DARK_BORDER = "#67C99D";
const DARK_TEXT = "#9BE0C1";

const darkUserManagementStyles = (theme) => {
  if (theme.palette.mode !== "dark") return {};

  const surfaces = theme.palette.surfaces || {};
  const card = surfaces.card || "#13251d";
  const section = surfaces.section || "#172b22";
  const nested = surfaces.nested || "#1b3328";
  const hover = surfaces.hover || "#214333";

  return {
    ".user-management-page": {
      color: theme.palette.text.primary
    },

    ".user-management-page .MuiPaper-root": {
      backgroundImage: "none !important",
      backgroundColor: `${card} !important`,
      color: `${theme.palette.text.primary} !important`,
      borderColor: `${DARK_BORDER} !important`
    },

    ".MuiDialog-paper, .MuiPopover-paper, .MuiMenu-paper": {
      backgroundImage: "none !important",
      backgroundColor: `${card} !important`,
      color: `${theme.palette.text.primary} !important`,
      border: `1px solid ${DARK_BORDER} !important`
    },

    ".MuiDialog-paper .MuiButton-root, .MuiDialog-paper .MuiIconButton-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${DARK_TEXT} !important`,
      border: `1px solid ${DARK_BORDER} !important`,
      boxShadow: "none !important"
    },

    ".MuiDialog-paper .MuiButton-root:hover, .MuiDialog-paper .MuiIconButton-root:hover": {
      backgroundColor: "transparent !important",
      color: "#C9F2DF !important",
      borderColor: `${DARK_BORDER} !important`
    },

    ".MuiDialog-paper .MuiChip-root, .MuiDialog-paper .MuiAlert-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      border: `1px solid ${DARK_BORDER} !important`
    },

    ".MuiDialog-paper .MuiOutlinedInput-root": {
      backgroundColor: "transparent !important",
      color: `${theme.palette.text.primary} !important`
    },

    ".MuiDialog-paper .MuiOutlinedInput-notchedOutline": {
      borderColor: `${DARK_BORDER} !important`
    },


    ".user-management-page .MuiButton-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${DARK_TEXT} !important`,
      border: `1px solid ${DARK_BORDER} !important`,
      boxShadow: "none !important",
      borderRadius: "10px !important"
    },

    ".user-management-page .MuiButton-root:hover": {
      backgroundColor: "transparent !important",
      color: "#C9F2DF !important",
      borderColor: `${DARK_BORDER} !important`,
      boxShadow: "0 0 0 1px rgba(103,201,157,.18) !important"
    },

    ".user-management-page .MuiButton-root.Mui-disabled": {
      backgroundColor: "transparent !important",
      color: "rgba(155,224,193,.42) !important",
      borderColor: "rgba(103,201,157,.35) !important"
    },

    ".user-management-page .MuiIconButton-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${DARK_TEXT} !important`,
      border: `1px solid ${DARK_BORDER} !important`,
      boxShadow: "none !important"
    },

    ".user-management-page .MuiIconButton-root:hover": {
      backgroundColor: "transparent !important",
      color: "#C9F2DF !important",
      borderColor: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiChip-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${DARK_TEXT} !important`,
      border: `1px solid ${DARK_BORDER} !important`,
      boxShadow: "none !important"
    },

    ".user-management-page .MuiOutlinedInput-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${theme.palette.text.primary} !important`
    },

    ".user-management-page .MuiOutlinedInput-notchedOutline": {
      borderColor: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, .user-management-page .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiInputLabel-root, .user-management-page .MuiFormHelperText-root": {
      color: `${theme.palette.text.secondary} !important`
    },

    ".user-management-page .MuiCheckbox-root": {
      color: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiCheckbox-root.Mui-checked": {
      color: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiAlert-root": {
      backgroundColor: "transparent !important",
      backgroundImage: "none !important",
      color: `${theme.palette.text.primary} !important`,
      border: `1px solid ${DARK_BORDER} !important`
    },

    ".user-management-page .MuiAlert-icon": {
      color: `${DARK_TEXT} !important`
    },

    ".user-management-page .MuiTabs-root": {
      backgroundColor: "transparent !important",
      borderBottom: `1px solid ${DARK_BORDER} !important`
    },

    ".user-management-page .MuiTab-root": {
      backgroundColor: "transparent !important",
      color: `${theme.palette.text.secondary} !important`
    },

    ".user-management-page .MuiTab-root.Mui-selected": {
      color: `${DARK_TEXT} !important`
    },

    ".user-management-page .MuiTabs-indicator": {
      backgroundColor: `${DARK_BORDER} !important`
    },

    ".user-management-page .MuiAutocomplete-paper, .user-management-page .MuiMenu-list": {
      backgroundColor: `${card} !important`,
      color: `${theme.palette.text.primary} !important`
    },

    ".MuiAutocomplete-paper": {
      backgroundColor: `${card} !important`,
      color: `${theme.palette.text.primary} !important`,
      border: `1px solid ${DARK_BORDER} !important`
    },

    ".MuiAutocomplete-option": {
      backgroundColor: "transparent !important",
      color: `${theme.palette.text.primary} !important`
    },

    ".MuiAutocomplete-option:hover, .MuiAutocomplete-option[aria-selected='true']": {
      backgroundColor: `${hover} !important`
    },

    ".user-management-page .dark-section-header": {
      backgroundColor: `${section} !important`,
      borderBottom: `1px solid ${DARK_BORDER} !important`
    },

    ".user-management-page .dark-nested-surface": {
      backgroundColor: `${nested} !important`,
      borderColor: `${DARK_BORDER} !important`
    }
  };
};

const formPlatform = (form) =>
  form?.platform ||
  (form?.isWeb === true || form?.isWeb === 1 ? "web" : "desktop");

const formPlatformLabel = (form) =>
  formPlatform(form) === "web" ? "ويب" : "ديسكتوب";


/*
 * UserJop يظل هو الـ Legacy index القديم كما هو.
 * أسماء الوظائف نفسها تأتي من HR_JobTitle.
 * لا نستخدم index الخاص بـ map نهائياً عند الحفظ.
 */

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
};

const getUserGuid = () => {
  const currentUser = readUser();
  return String(
    currentUser?.guid ||
    currentUser?.Guid ||
    currentUser?.userGuid ||
    currentUser?.UserGuid ||
    currentUser?.USER_GUID ||
    currentUser?.USER_GUID____ ||
    localStorage.getItem("userGuid") ||
    localStorage.getItem("UserGuid") ||
    localStorage.getItem("guid") ||
    ""
  ).trim();
};

const norm = (value) =>
  String(value ?? "").trim().toLowerCase();

const lookupFieldSx = {
  "& .MuiOutlinedInput-root": {
    position: "relative",
    paddingLeft: "42px !important",
    paddingRight: "12px !important"
  },
  "& .MuiInputBase-input": {
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    textAlign: "right"
  },
  "& .MuiInputAdornment-positionEnd": {
    position: "absolute",
    left: 4,
    right: "auto",
    margin: "0 !important",
    height: "100%"
  },
  "& .MuiInputAdornment-positionEnd .MuiIconButton-root": {
    width: 34,
    height: 34,
    p: 0.5,
    color: primary
  }
};

const emptyUser = () => ({
  guid: "",
  code: "",
  fullName: "",
  userName: "",
  password: "",
  isUse: true,

  // فروع مخصصة للتقارير
  chkBranch: false,
  branchGuid: ZERO_GUID,
  branchName: "",

  // بيانات وظيفية
  chkAmount: false,
  chkOtherFess: false,
  sellerGuid: ZERO_GUID,
  sellerName: "",
  branchForWork: ZERO_GUID,
  branchForWorkName: "",
  chkTrainer: false,
  trainerGuid: ZERO_GUID,
  trainerName: "",
  userJop: -1,
  departmentGuid: ZERO_GUID,
  departmentName: "",
  chkAccept: false,

  // موجودة في ShowUserInfo بالديسكتوب، لكن الحفظ القديم معلق.
  chkAllowCompany: false
});

const emptyPermission = (form) => ({
  name: form?.name || "",
  guid: form?.guid || "",
  platform: formPlatform(form),
  isWeb: formPlatform(form) === "web",
  webItemKey: form?.webItemKey || "",
  webRoute: form?.webRoute || "",
  add: false,
  edit: false,
  del: false,
  print: false,
  find: false,
  view: false
});

// ============================================================
// صفوف الصلاحيات (Memo): المستخدم اللي ليه مئات الشاشات كان أي تعديل
// بيرسم كل الصفوف من الأول. دلوقتي الصف اللي اتغير بس هو اللي بيترسم.
// ============================================================
const PERMISSION_FIELDS = [
  ["add", "جديد"],
  ["edit", "تعديل"],
  ["del", "حذف"],
  ["print", "طباعة"],
  ["find", "بحث"],
  ["view", "عرض"]
];

// الصفوف دي بتترسم بالمئات (System Admin ≈ 160 صف × 6 = ~1000 checkbox)،
// فبنستخدم عناصر HTML عادية + ستايل ثابت بدل MUI Checkbox/Chip/Box
// عشان فتح تابة الصلاحيات ميعملش لاج.
const permStyles = {
  check: { width: 18, height: 18, margin: 0, cursor: "pointer", accentColor: primary },
  chip: {
    flexShrink: 0,
    height: 20,
    lineHeight: "18px",
    padding: "0 7px",
    border: "1px solid color-mix(in srgb, currentColor 35%, transparent)",
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 900,
    whiteSpace: "nowrap"
  },
  card: { padding: 5, border: `1px solid ${border}`, borderRadius: 4 },
  cardHead: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginBottom: 3 },
  cardName: { minWidth: 0, fontSize: 12, fontWeight: 900, lineHeight: 1.2 },
  cardGrid: { display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: 1 },
  cardLabel: { display: "flex", alignItems: "center", gap: 4, minWidth: 0, padding: "2px 2px", fontSize: 12, lineHeight: 1.1, cursor: "pointer" },
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(230px,1fr) repeat(6,70px)",
    alignItems: "center",
    minHeight: 42,
    borderBottom: `1px solid ${border}`
  },
  rowHead: { display: "flex", alignItems: "center", gap: 6, padding: "0 8px", minWidth: 0 },
  rowName: { minWidth: 0, flex: 1, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  cell: { display: "flex", justifyContent: "center", alignItems: "center", height: 42 }
};

const PermissionCard = React.memo(function PermissionCard({ p, index, onChange }) {
  return (
    <div style={permStyles.card}>
      <div style={permStyles.cardHead}>
        <span style={permStyles.cardName}>{p.name}</span>
        <span style={permStyles.chip}>{formPlatformLabel(p)}</span>
      </div>

      <div style={permStyles.cardGrid}>
        {PERMISSION_FIELDS.map(([field, label]) => (
          <label key={field} style={permStyles.cardLabel}>
            <input
              type="checkbox"
              style={{ ...permStyles.check, width: 16, height: 16 }}
              checked={Boolean(p[field])}
              onChange={(e) => onChange(index, field, e.target.checked)}
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
});

const PermissionRow = React.memo(function PermissionRow({ p, index, onChange }) {
  return (
    <div style={permStyles.row}>
      <div style={permStyles.rowHead}>
        <span style={permStyles.rowName} title={p.name}>{p.name}</span>
        <span style={permStyles.chip}>{formPlatformLabel(p)}</span>
      </div>

      {PERMISSION_FIELDS.map(([field, label]) => (
        <label key={field} style={permStyles.cell}>
          <input
            type="checkbox"
            aria-label={`${label} - ${p.name}`}
            style={permStyles.check}
            checked={Boolean(p[field])}
            onChange={(e) => onChange(index, field, e.target.checked)}
          />
        </label>
      ))}
    </div>
  );
});

function LookupDialog(props) {
  useNicknames();
  return <LookupDialogBody {...props} />;
}

function LookupDialogBody({
  open,
  title,
  rows,
  loading,
  error,
  search,
  setSearch,
  onClose,
  onPick,
  columns = []
}) {
  return (
    <Dialog sx={uiLayout.dialogLayoutSx}
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      dir="rtl"
      PaperProps={{
        sx: {
          borderRadius: { xs: 1.5, sm: 2.5 },
          maxHeight: { xs: "92vh", sm: "82vh" },
          m: { xs: 1, sm: 2 }
        }
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 900,
          fontSize: { xs: 18, sm: 22 },
          py: { xs: 1, sm: 1.5 }
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent
        dividers
        sx={{ p: { xs: 1, sm: 2 } }}
      >
        <TextField InputLabelProps={{ shrink: true }}
          autoFocus
          fullWidth
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="بحث..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
          sx={uiLayout.withUiSx({
            mb: { xs: 0.7, sm: 1 },
            "& .MuiInputBase-root": {
              minHeight: { xs: 34, sm: 38 }
            },
            "& input": {
              fontSize: { xs: 12, sm: 13 }
            }
          }, uiLayout.formFieldSx)}
        />

        {loading ? (
          <Box sx={{ py: 5, textAlign: "center" }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box
            sx={{
              display: "grid",
              gap: 0.7
            }}
          >
            {rows.map((row, index) => (
              <Paper
                key={row.guid || row.code || index}
                variant="outlined"
                onDoubleClick={() => onPick(row)}
                sx={(theme) => ({
                  px: { xs: 0.7, sm: 1 },
                  py: { xs: 0.5, sm: 0.7 },
                  cursor: "pointer",
                  borderColor: theme.palette.mode === "dark" ? DARK_BORDER : border,
                  backgroundColor: theme.palette.mode === "dark"
                    ? (theme.palette.surfaces?.card || "#13251d")
                    : undefined,
                  "&:hover": {
                    bgcolor: theme.palette.mode === "dark"
                      ? (theme.palette.surfaces?.hover || "#214333")
                      : "#eef8f3",
                    borderColor: theme.palette.mode === "dark" ? DARK_BORDER : primary
                  }
                })}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "52px minmax(0,1fr) 58px",
                      sm: "70px minmax(0,1fr) 90px 60px"
                    },
                    alignItems: "center",
                    gap: { xs: 0.45, sm: 0.8 }
                  }}
                >
                  <Box>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: { xs: 12, sm: 12 } }}
                    >
                      {columns[0]?.label || "الكود"}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: { xs: 12, sm: 13 }
                      }}
                    >
                      {row[columns[0]?.key] ?? "-"}
                    </Typography>
                  </Box>

                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: { xs: 12, sm: 12 } }}
                    >
                      {columns[1]?.label || "الاسم"}
                    </Typography>
                    <Typography
                      noWrap
                      sx={{
                        fontWeight: 800,
                        fontSize: { xs: 12, sm: 13 }
                      }}
                    >
                      {columns[1]?.label === "اسم المستخدم"
                        ? withNickname(row[columns[1]?.key], row.guid) || "-"
                        : row[columns[1]?.key] ?? "-"}
                    </Typography>
                  </Box>

                  <Box sx={{ display: { xs: "none", sm: "block" } }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: 12 }}
                    >
                      {columns[2]?.label || "الحالة"}
                    </Typography>
                    <Typography sx={{ fontWeight: 800, fontSize: 13 }}>
                      {row[columns[2]?.key] ?? "-"}
                    </Typography>
                  </Box>

                  <Button
                    size="small"
                    onClick={() => onPick(row)}
                    sx={uiLayout.withUiSx({
                      minWidth: 0,
                      px: { xs: 0.4, sm: 0.7 },
                      fontSize: { xs: 12, sm: 12 }
                    }, uiLayout.buttonSx)}
                  >
                    اختيار
                  </Button>
                </Box>
              </Paper>
            ))}

            {!rows.length && (
              <Alert severity="info">
                لا توجد نتائج.
              </Alert>
            )}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={uiLayout.dialogActionsSx}>
        <Button sx={uiLayout.buttonSx} onClick={onClose}>إغلاق</Button>
      </DialogActions>
    </Dialog>
  );
}

export default function UserManagement() {
  const { version: nicknamesVersion } = useNicknames();
  const theme = useTheme();
  const isDesktop = useMediaQuery(
    `(min-width:${DESKTOP_BREAKPOINT}px)`,
    { noSsr: true }
  );
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const userGuid = useMemo(() => getUserGuid(), []);

  const [mobileSidebarOpen, setMobileSidebarOpen] =
    useState(false);

  const [permissionLoading, setPermissionLoading] =
    useState(true);
  const [authorized, setAuthorized] = useState(false);

  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [model, setModel] = useState(emptyUser());
  const documentsTabRef = useRef(null);

  const [menus, setMenus] = useState([]);
  const [forms, setForms] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [availableBranches, setAvailableBranches] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const [jobTitles, setJobTitles] = useState([]);
  const [jobTitlesLoading, setJobTitlesLoading] = useState(false);
  const [jobTitlesError, setJobTitlesError] = useState("");

  // باكدجات الصلاحيات / نسخ صلاحيات: "apply" | "copy" | "manage" | ""
  const [packagesMode, setPackagesMode] = useState("");
  const [bulkOpen, setBulkOpen] = useState(false);
  const [desktopAccessOpen, setDesktopAccessOpen] = useState(false);

  const [lookup, setLookup] = useState({
    open: false,
    type: "",
    title: "",
    rows: [],
    loading: false,
    search: ""
  });

  const isEdit = Boolean(model.guid);

  // الاسم الحركي (HR_UserNickname) — بيتحفظ بعد حفظ المستخدم
  const [nickname, setNickname] = useState("");
  useEffect(() => {
    setNickname(getNickname(model.guid, model.fullName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [model.guid, nicknamesVersion]);

  const setField = useCallback((field, value) => {
    setModel((current) => ({
      ...current,
      [field]: value
    }));
  }, []);

  // ============================================================
  // Permission - one source: Form_Name + User_Premision
  // ============================================================
  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const token = String(localStorage.getItem("token") || "").trim();
        if (!token) {
          if (alive) setAuthorized(false);
          return;
        }

        const response = await fetch(
          `${API_BASE_URL}/api/screen-access/me?key=user-management`,
          {
            cache: "no-store",
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
          }
        );
        const result = await response.json().catch(() => null);
        if (alive) setAuthorized(response.ok && result?.allowed === true);
      } catch {
        if (alive) setAuthorized(false);
      } finally {
        if (alive) setPermissionLoading(false);
      }
    })();

    return () => { alive = false; };
  }, []);

  // ============================================================
  // Bootstrap: menus + forms + branches
  // ============================================================
  const loadBootstrap = useCallback(async () => {
    if (!authorized || !userGuid) return;

    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/user-management/bootstrap?userGuid=${encodeURIComponent(userGuid)}`,
        { cache: "no-store" }
      );

      const result = await response
        .json()
        .catch(() => null);

      if (!response.ok) {
        throw new Error(
          [
            result?.message,
            result?.error,
            result?.detail
          ]
            .filter(Boolean)
            .join(" — ") ||
          "تعذر تحميل إعدادات شاشة المستخدم"
        );
      }

      const data = result?.data || {};

      const loadedMenus =
        Array.isArray(data?.menus)
          ? data.menus
          : [];

      const loadedForms =
        Array.isArray(data?.forms)
          ? data.forms
          : [];

      const loadedBranches =
        Array.isArray(data?.branches)
          ? data.branches
          : [];

      setMenus(
        loadedMenus.map((item) => ({
          ...item,
          view: false
        }))
      );

      setForms(
        loadedForms.map((form) => ({
          ...form,
          platform: formPlatform(form),
          isWeb: formPlatform(form) === "web"
        }))
      );

      // مطابق للديسكتوب: FormGrid يبدأ فارغًا،
      // ولا نضيف الشاشة إلا عند اختيارها.
      setPermissions([]);

      setAvailableBranches(loadedBranches);
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "تعذر التحميل",
        text:
          e?.message ||
          "تعذر تحميل إعدادات شاشة المستخدم"
      });
    } finally {
      setLoading(false);
    }
  }, [authorized, userGuid]);

  useEffect(() => {
    if (authorized) {
      loadBootstrap();
    }
  }, [authorized, loadBootstrap]);

  // ============================================================
  // HR Job Titles
  // UserJop remains the legacy code/index stored in User_Info.
  // Legacy code 12 is kept in DB but hidden for new selections.
  // ============================================================
  const loadJobTitles = useCallback(async () => {
    if (!authorized) return;

    setJobTitlesLoading(true);
    setJobTitlesError("");

    try {
      const token = String(
        localStorage.getItem("token") || ""
      ).trim();

      const response = await fetch(
        `${API_BASE_URL}/api/hr/job-titles/lookups`,
        {
          cache: "no-store",
          headers: {
            Accept: "application/json",
            ...(token
              ? { Authorization: `Bearer ${token}` }
              : {})
          }
        }
      );

      const result = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(
          result?.message ||
            "تعذر تحميل الوظائف والمسميات الوظيفية"
        );
      }

      const rows = Array.isArray(result?.data)
        ? result.data
        : [];

      // User_Info.UserJop is still the Desktop legacy integer.
      // Therefore this screen can safely select only HR titles that have
      // a valid LegacyJobCode, while keeping the title/name source in HR_JobTitle.
      const compatibleRows = rows
        .filter((job) => {
          const active =
            job?.isActive === true ||
            job?.isActive === 1 ||
            String(job?.isActive || "").toLowerCase() === "true";

          const rawLegacyCode = job?.legacyJobCode;
          const hasLegacyCode =
            rawLegacyCode !== null &&
            rawLegacyCode !== undefined &&
            String(rawLegacyCode).trim() !== "" &&
            Number.isInteger(Number(rawLegacyCode));

          return (
            active &&
            hasLegacyCode &&
            Number(rawLegacyCode) !== 12
          );
        })
        .sort(
          (a, b) =>
            Number(a.legacyJobCode) -
            Number(b.legacyJobCode)
        );

      setJobTitles(compatibleRows);

      if (!compatibleRows.length && rows.length) {
        setJobTitlesError(
          "المسميات موجودة في الموارد البشرية، لكن لا يوجد منها مسميات مرتبطة بكود الوظيفة القديم المستخدم في حسابات المستخدمين."
        );
      }
    } catch (e) {
      console.error("Failed to load HR job titles:", e);
      setJobTitles([]);
      setJobTitlesError(
        e?.message ||
          "تعذر تحميل الوظائف والمسميات الوظيفية"
      );
    } finally {
      setJobTitlesLoading(false);
    }
  }, [authorized]);

  useEffect(() => {
    if (authorized) {
      loadJobTitles();
    }
  }, [authorized, loadJobTitles]);

  // ============================================================
  // New
  // ============================================================
  const newUser = useCallback(() => {
    setModel(emptyUser());
    setSelectedBranches([]);

    setMenus((current) =>
      current.map((item) => ({
        ...item,
        view: false
      }))
    );

    // مطابق CMDNew في الديسكتوب: FormGrid.Rows.Clear()
    setPermissions([]);

    setTab(0);
  }, [forms]);

  // ============================================================
  // Lookups
  // ============================================================
  const openLookup = useCallback((type, title) => {
    setLookup({
      open: true,
      type,
      title,
      rows: [],
      loading: true,
      error: "",
      search: ""
    });
  }, []);

  const closeLookup = useCallback(() => {
    setLookup((current) => ({
      ...current,
      open: false
    }));
  }, []);

  useEffect(() => {
    if (!lookup.open || !authorized) return;

    let cancelled = false;
    const timer = setTimeout(async () => {
      setLookup((current) => ({
        ...current,
        loading: true,
        error: ""
      }));

      try {
        const params =
          new URLSearchParams({
            userGuid,
            q: lookup.search || ""
          });

        let url = "";

        if (lookup.type === "users") {
          url = `${API_BASE_URL}/api/user-management/users?${params}`;
        } else if (lookup.type === "branchForWork") {
          url = `${API_BASE_URL}/api/user-management/branches?${params}`;
        } else if (lookup.type === "seller") {
          url = `${API_BASE_URL}/api/user-management/salesmen?${params}`;
        } else if (lookup.type === "trainer") {
          if (
            model.branchForWork &&
            model.branchForWork !== ZERO_GUID
          ) {
            params.set(
              "branchGuid",
              model.branchForWork
            );
          }

          url = `${API_BASE_URL}/api/user-management/trainers?${params}`;
        } else if (lookup.type === "department") {
          url = `${API_BASE_URL}/api/user-management/departments?${params}`;
        }

        if (!url) return;

        const response = await fetch(url, {
          cache: "no-store"
        });

        const result = await response
          .json()
          .catch(() => null);

        if (!response.ok) {
          throw new Error(
            result?.message ||
            "تعذر تحميل القائمة"
          );
        }

        if (cancelled) return;
        setLookup((current) => ({
          ...current,
          rows:
            Array.isArray(result) ? result : Array.isArray(result?.data)
              ? result.data
              : []
        }));
      } catch (e) {
        if (cancelled) return;
        setLookup((current) => ({
          ...current,
          rows: [],
          error: e?.message || "تعذر تحميل القائمة. يرجى المحاولة مرة أخرى."
        }));
      } finally {
        if (!cancelled) setLookup((current) => ({
          ...current,
          loading: false
        }));
      }
    }, 250);

    return () => { cancelled = true; clearTimeout(timer); };
  }, [
    lookup.open,
    lookup.type,
    lookup.search,
    authorized,
    userGuid,
    model.branchForWork
  ]);

  const loadUser = useCallback(
    async (code) => {
      closeLookup();
      setLoading(true);

      try {
        const response = await fetch(
          `${API_BASE_URL}/api/user-management/users/${encodeURIComponent(code)}?userGuid=${encodeURIComponent(userGuid)}`,
          { cache: "no-store" }
        );

        const result = await response
          .json()
          .catch(() => null);

        if (!response.ok) {
          throw new Error(
            result?.message ||
            "تعذر تحميل بيانات المستخدم"
          );
        }

        const data = result?.data || {};

        setModel({
          ...emptyUser(),
          ...(data?.user || {})
        });

        const userMenus =
          Array.isArray(data?.menus)
            ? data.menus
            : [];

        const menuMap =
          new Map(
            userMenus.map((item) => [
              norm(item.guid),
              Boolean(item.view)
            ])
          );

        setMenus((current) =>
          current.map((item) => ({
            ...item,
            view:
              menuMap.get(norm(item.guid)) ||
              false
          }))
        );

        const userPermissions =
          Array.isArray(data?.permissions)
            ? data.permissions
            : [];

        const permissionMap =
          new Map(
            userPermissions.map((item) => [
              norm(item.guid),
              item
            ])
          );

        setPermissions(
          userPermissions.map((p) => {
            const form =
              forms.find(
                (f) =>
                  norm(f.guid) === norm(p.guid)
              );

            return {
              name:
                p.name ||
                form?.name ||
                "",
              guid: p.guid,
              platform: p.platform || formPlatform(form || p),
              isWeb:
                p.isWeb === true ||
                p.isWeb === 1 ||
                formPlatform(form || p) === "web",
              webItemKey: p.webItemKey || form?.webItemKey || "",
              webRoute: p.webRoute || form?.webRoute || "",
              add: Boolean(p.add),
              edit: Boolean(p.edit),
              del: Boolean(p.del),
              print: Boolean(p.print),
              find: Boolean(p.find),
              view: Boolean(p.view)
            };
          })
        );

        setSelectedBranches(
          Array.isArray(data?.branches)
            ? data.branches
            : []
        );

        setTab(0);
      } catch (e) {
        await Swal.fire({
          icon: "error",
          title: "تعذر التحميل",
          text:
            e?.message ||
            "تعذر تحميل بيانات المستخدم"
        });
      } finally {
        setLoading(false);
      }
    },
    [closeLookup, forms, userGuid]
  );

  const pickLookup = useCallback(
    (row) => {
      if (lookup.type === "users") {
        loadUser(row.code);
        return;
      }

      if (lookup.type === "branchForWork") {
        setModel((current) => ({
          ...current,
          branchForWork: row.guid || ZERO_GUID,
          branchForWorkName: row.name || "",
          // تغيير الفرع يلغي المدرب لو كان تابعًا لفرع آخر
          trainerGuid: ZERO_GUID,
          trainerName: ""
        }));
      }

      if (lookup.type === "seller") {
        setModel((current) => ({
          ...current,
          sellerGuid: row.guid || ZERO_GUID,
          sellerName: row.name || ""
        }));
      }

      if (lookup.type === "trainer") {
        setModel((current) => ({
          ...current,
          trainerGuid: row.guid || ZERO_GUID,
          trainerName: row.name || ""
        }));
      }

      if (lookup.type === "department") {
        setModel((current) => ({
          ...current,
          departmentGuid:
            row.guid || ZERO_GUID,
          departmentName: row.name || ""
        }));
      }

      closeLookup();
    },
    [lookup.type, closeLookup, loadUser]
  );

  // ============================================================
  // Permissions editing
  // ============================================================
  const updatePermission = useCallback(
    (index, field, value) => {
      setPermissions((current) => {
        const next = current.slice();
        next[index] = {
          ...next[index],
          [field]: value
        };
        return next;
      });
    },
    []
  );

  const fullControl = useCallback(() => {
    setMenus((current) =>
      current.map((item) => ({
        ...item,
        view: true
      }))
    );

    setPermissions(
      forms.map((form) => ({
        name: form.name,
        guid: form.guid,
        platform: formPlatform(form),
        isWeb: formPlatform(form) === "web",
        webItemKey: form.webItemKey || "",
        webRoute: form.webRoute || "",
        add: true,
        edit: true,
        del: true,
        print: true,
        find: true,
        view: true
      }))
    );
  }, [forms]);

  const deleteAllPermissions = useCallback(() => {
    setMenus((current) =>
      current.map((item) => ({
        ...item,
        view: false
      }))
    );

    // مطابق CmdDelAll: FormGrid.Rows.Clear()
    setPermissions([]);
  }, []);

  // تطبيق باكدج / صلاحيات مستخدم تاني على المستخدم المفتوح.
  // merge: أي صلاحية موجودة في الاتنين بتتجمع (OR) — replace: صلاحيات الباكدج بس.
  const applyPermissionSet = useCallback(
    (set, mode) => {
      const replace = mode === "replace";
      const menuGuids = new Set(
        (set?.menus || []).filter((m) => m.view).map((m) => norm(m.guid))
      );

      setMenus((current) =>
        current.map((item) => ({
          ...item,
          view: replace
            ? menuGuids.has(norm(item.guid))
            : Boolean(item.view) || menuGuids.has(norm(item.guid))
        }))
      );

      setPermissions((current) => {
        const next = replace ? [] : current.map((p) => ({ ...p }));
        const indexByGuid = new Map(next.map((p, i) => [norm(p.guid), i]));

        (set?.permissions || []).forEach((p) => {
          const form = forms.find((f) => norm(f.guid) === norm(p.guid));
          if (!form) return;

          const flags = {
            add: Boolean(p.add),
            edit: Boolean(p.edit),
            del: Boolean(p.del),
            print: Boolean(p.print),
            find: Boolean(p.find),
            view: Boolean(p.view)
          };

          const existingIndex = indexByGuid.get(norm(form.guid));
          if (existingIndex !== undefined) {
            const existing = next[existingIndex];
            next[existingIndex] = {
              ...existing,
              ...Object.fromEntries(
                Object.entries(flags).map(([key, value]) => [key, Boolean(existing[key]) || value])
              )
            };
          } else {
            indexByGuid.set(norm(form.guid), next.length);
            next.push({ ...emptyPermission(form), ...flags });
          }
        });

        return next;
      });

      setTab(1);
    },
    [forms]
  );

  // الشاشات اللي لسه مش مضافة (قائمة "ابحث في كل الشاشات"):
  // كانت بتتحسب مع كل رسم بمقارنة كل شاشة بكل صلاحية؛ دلوقتي Set ومرة واحدة لكل تغيير.
  const availableForms = useMemo(() => {
    const used = new Set(permissions.map((item) => norm(item.guid)));
    return forms.filter((form) => !used.has(norm(form.guid)));
  }, [forms, permissions]);

  const addFormToPermissions = useCallback(
    (form) => {
      setPermissions((current) => {
        const existing = current.find(
          (item) =>
            norm(item.guid) === norm(form.guid)
        );

        if (existing) return current;

        return [
          ...current,
          emptyPermission(form)
        ];
      });
    },
    []
  );

  // ============================================================
  // Branch assignment dual list
  // ============================================================
  const selectedBranchGuids =
    useMemo(
      () =>
        new Set(
          selectedBranches.map((b) =>
            norm(b.guid)
          )
        ),
      [selectedBranches]
    );

  const unselectedBranches =
    useMemo(
      () =>
        availableBranches.filter(
          (b) =>
            !selectedBranchGuids.has(
              norm(b.guid)
            )
        ),
      [
        availableBranches,
        selectedBranchGuids
      ]
    );

  const addAllowedBranch = useCallback((branch) => {
    setSelectedBranches((current) => {
      if (
        current.some(
          (item) =>
            norm(item.guid) ===
            norm(branch.guid)
        )
      ) {
        return current;
      }

      return [...current, branch];
    });
  }, []);

  const removeAllowedBranch = useCallback(
    (guid) => {
      setSelectedBranches((current) =>
        current.filter(
          (item) =>
            norm(item.guid) !== norm(guid)
        )
      );
    },
    []
  );

  // ============================================================
  // Save / Update
  // ============================================================
  const validate = useCallback(() => {
    if (!model.fullName.trim())
      return "برجاء إدخال اسم الموظف";

    if (!model.userName.trim())
      return "برجاء إدخال اسم المستخدم";

    if (!model.password.trim())
      return "برجاء إدخال كلمة المرور";

    // مطابق للديسكتوب: مندوب البيع مطلوب.
    if (
      !model.sellerGuid ||
      model.sellerGuid === ZERO_GUID
    ) {
      return "برجاء اختيار حساب مندوب البيع أولاً";
    }

    if (
      model.chkTrainer &&
      (
        !model.trainerGuid ||
        model.trainerGuid === ZERO_GUID
      )
    ) {
      return "المستخدم محدد كمدرب؛ برجاء اختيار المدرب";
    }

    return "";
  }, [model]);

  const save = useCallback(async () => {
    const validation = validate();

    if (validation) {
      await Swal.fire({
        icon: "warning",
        title: "راجع البيانات",
        text: validation
      });
      return;
    }

    let reason = "";

    if (isEdit) {
      const result = await Swal.fire({
        title: "سبب التعديل",
        input: "textarea",
        inputPlaceholder:
          "اكتب سبب تعديل بيانات المستخدم...",
        showCancelButton: true,
        confirmButtonText: "حفظ التعديل",
        cancelButtonText: "رجوع",
        inputValidator: (value) =>
          !String(value || "").trim()
            ? "سبب التعديل مطلوب"
            : undefined
      });

      if (!result.isConfirmed) return;
      reason = String(result.value || "").trim();
    }

    const payload = {
      actorUserGuid: userGuid,
      reason,
      user: {
        ...model,

        // الـ API يعرف Code و Guid كنصوص.
        // ShowUserInfo/قائمة المستخدمين قد يعيدان Code كرقم،
        // لذلك نحوله صراحةً قبل JSON.stringify حتى لا يفشل Model Binding.
        code: String(model.code ?? ""),
        guid: String(model.guid ?? ""),

        userJop:
          Number.isFinite(Number(model.userJop))
            ? Number(model.userJop)
            : -1
      },
      menus: menus.map((item) => ({
        guid: item.guid,
        view: Boolean(item.view)
      })),
      permissions: permissions.map((p) => ({
        guid: p.guid,
        add: Boolean(p.add),
        edit: Boolean(p.edit),
        del: Boolean(p.del),
        print: Boolean(p.print),
        find: Boolean(p.find),
        view: Boolean(p.view)
      })),
      branches: selectedBranches.map(
        (item) => item.guid
      )
    };

    setSaving(true);

    try {
      const response = await fetch(
        isEdit
          ? `${API_BASE_URL}/api/user-management/${encodeURIComponent(model.guid)}`
          : `${API_BASE_URL}/api/user-management`,
        {
          method: isEdit ? "PUT" : "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const raw = await response.text();
      let result = null;

      try {
        result = raw ? JSON.parse(raw) : null;
      } catch {
        result = null;
      }

      if (!response.ok) {
        throw new Error(
          [
            result?.message,
            result?.error,
            result?.detail
          ]
            .filter(Boolean)
            .join(" — ") ||
          raw ||
          "تعذر حفظ المستخدم"
        );
      }

      const saved = result?.data || {};

      setModel((current) => ({
        ...current,
        guid: saved.guid || current.guid,
        code: saved.code || current.code
      }));

      // Reuse the existing sidebar refresh mechanism; no full-page reload.
      window.dispatchEvent(
        new CustomEvent("sstli:sidebar-refresh", {
          detail: {
            reason: "user-permissions-updated",
            targetUserGuid:
              saved.guid || model.guid || null
          }
        })
      );

      const savedGuid = saved.guid || model.guid;
      if (savedGuid && nickname.trim() !== getNickname(savedGuid, model.fullName)) {
        let actorGuid = null;
        try {
          const currentUser = JSON.parse(localStorage.getItem("user") || "null");
          actorGuid = currentUser?.guid || currentUser?.Guid || null;
        } catch {
          actorGuid = null;
        }
        await saveNickname(savedGuid, nickname.trim(), actorGuid);
      }

      // الدفاتر اتغيّرت في تابة "الدفاتر"؟ نحفظها مع المستخدم
      const documentsResult =
        await documentsTabRef.current?.saveIfDirty?.();

      await Swal.fire({
        icon: "success",
        title: isEdit
          ? "تم تعديل المستخدم"
          : "تم حفظ المستخدم",
        text:
          (result?.message ||
          "تمت العملية بنجاح") +
          (documentsResult ? " وتم حفظ الدفاتر." : "")
      });
    } catch (e) {
      await Swal.fire({
        icon: "error",
        title: "تعذر الحفظ",
        text:
          e?.message ||
          "تعذر حفظ بيانات المستخدم"
      });
    } finally {
      setSaving(false);
    }
  }, [
    validate,
    isEdit,
    userGuid,
    model,
    menus,
    permissions,
    selectedBranches,
    nickname
  ]);

  // ============================================================
  // Render states
  // ============================================================
  if (permissionLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "grid",
          placeItems: "center"
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!authorized) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">
          لا توجد لديك صلاحية إضافة مستخدم ضمن قائمة ملف.
        </Alert>
      </Box>
    );
  }

  const lookupColumns =
    lookup.type === "users"
      ? [
          { key: "code", label: "الكود" },
          { key: "name", label: "اسم المستخدم" },
          { key: "status", label: "الحالة" }
        ]
      : [
          { key: "code", label: "الكود" },
          { key: "name", label: "البيان" },
          { key: "status", label: "الحالة" }
        ];

  const content = (
    <PageContainer
      dir="rtl"
      sx={{
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        bgcolor: theme.palette.mode === "dark"
          ? theme.palette.background.default
          : soft,
        
      }}
    >
      <Paper
        elevation={0}
        sx={{
          border: `1px solid ${border}`,
          borderRadius: { xs: 1.2, sm: 2 },
          overflow: "hidden",

          "& .MuiInputBase-root": {
            minHeight: { xs: 34, sm: 38 }
          },
          "& .MuiInputBase-input": {
            fontSize: { xs: 12, sm: 13.5 },
            py: { xs: 0.55, sm: 0.8 }
          },
          "& .MuiInputLabel-root": {
            fontSize: { xs: 12, sm: 12.5 }
          },
          "& .MuiButton-root": {
            minHeight: { xs: 32, sm: 36 },
            fontSize: { xs: 12, sm: 13.5 },
            lineHeight: 1.15
          },
          "& .MuiSvgIcon-root": {
            fontSize: { xs: 18, sm: 20 }
          }
        }}
      >
        <Box
          sx={uiLayout.withUiSx((theme) => ({
            bgcolor:
              theme.palette.mode === "dark"
                ? (theme.palette.surfaces?.card || "#13251d")
                : primaryDark,
            color:
              theme.palette.mode === "dark"
                ? theme.palette.text.primary
                : "#fff",
            borderBottom:
              theme.palette.mode === "dark"
                ? `1px solid ${DARK_BORDER}`
                : "none",
            px: { xs: 1, sm: 1.5 },
            py: { xs: 0.7, sm: 0.9 },
            display: "flex",
            alignItems: "center",
            gap: 1
          }), uiLayout.mobileHeaderSx)}
        >
          {!isDesktop && (
            <IconButton
              onClick={() =>
                setMobileSidebarOpen(true)
              }
              sx={{ color: "#fff" }}
            >
              <MenuRoundedIcon />
            </IconButton>
          )}

          <PersonAddAlt1Icon />

          <Box sx={{ flex: 1 }}>
            <Typography variant="h1" sx={{ fontWeight: 900 }}
            >
              إضافة مستخدم
            </Typography>
          </Box>

          <Chip
            label={
              isEdit
                ? `تعديل المستخدم #${model.code}`
                : "مستخدم جديد"
            }
            size="small"
            sx={{
              bgcolor: "#fff",
              color: primaryDark,
              fontWeight: 900
            }}
          />
        </Box>

        <Box
          sx={{
            p: 1,
            borderBottom: `1px solid ${border}`
          }}
        >
          <Box
            sx={uiLayout.withUiSx({
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(3, minmax(0, 1fr))",
                sm: "repeat(3, max-content)"
              },
              gap: { xs: 0.5, sm: 0.75 },
              justifyContent: { sm: "start" }
            }, uiLayout.actionBarSx)}
          >
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={newUser}
              sx={uiLayout.withUiSx({
                bgcolor: "#1976d2",
                fontWeight: 900,
                minWidth: 0,
                px: { xs: 0.7, sm: 2 },
                fontSize: { xs: 12, sm: 13.5 },
                lineHeight: 1.1,
                whiteSpace: "normal"
              }, uiLayout.buttonSx)}
            >
              جديد
            </Button>

            <Button
              variant="outlined"
              startIcon={<SearchIcon />}
              onClick={() =>
                openLookup(
                  "users",
                  "قائمة المستخدمين"
                )
              }
              sx={uiLayout.withUiSx({
                fontWeight: 900,
                minWidth: 0,
                px: { xs: 0.7, sm: 2 },
                fontSize: { xs: 12, sm: 13.5 },
                lineHeight: 1.1,
                whiteSpace: "normal"
              }, uiLayout.buttonSx)}
            >
              بحث عن مستخدم
            </Button>

            <Button
              variant="contained"
              color="success"
              startIcon={
                saving
                  ? <CircularProgress size={18} color="inherit" />
                  : <SaveIcon />
              }
              onClick={save}
              disabled={saving || loading}
              sx={uiLayout.withUiSx({
                fontWeight: 900,
                minWidth: 0,
                px: { xs: 0.7, sm: 2 },
                fontSize: { xs: 12, sm: 13.5 },
                lineHeight: 1.1,
                whiteSpace: "normal"
              }, uiLayout.buttonSx)}
            >
              {isEdit
                ? "حفظ التعديل"
                : "حفظ"}
            </Button>
          </Box>
        </Box>

        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          variant={isMobile ? "fullWidth" : "standard"}
          scrollButtons={false}
          sx={{
            borderBottom: `1px solid ${border}`,
            minHeight: { xs: 42, sm: 48 },
            "& .MuiTab-root": {
              minHeight: { xs: 42, sm: 48 },
              py: { xs: 0.5, sm: 1 },
              px: { xs: 0.7, sm: 2 },
              fontSize: { xs: 12, sm: 14 }
            }
          }}
        >
          <Tab
            icon={<BadgeIcon />}
            iconPosition="start"
            label="بيانات أساسية"
          />
          <Tab
            icon={<SecurityIcon />}
            iconPosition="start"
            label="القوائم والصلاحيات"
          />
          <Tab
            icon={<MenuBookIcon />}
            iconPosition="start"
            label="الدفاتر"
            disabled={!isEdit}
          />
        </Tabs>

        {loading && (
          <Box
            sx={{
              p: 1,
              display: "flex",
              gap: 1,
              alignItems: "center"
            }}
          >
            <CircularProgress size={20} />
            <Typography>
              جاري التحميل...
            </Typography>
          </Box>
        )}

        {tab === 0 && (
          <Box sx={{ p: { xs: 0.75, sm: 1.25, md: 1.5 } }}>
            <Box
              sx={uiLayout.withUiSx({
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2,minmax(0,1fr))",
                  md: "repeat(4,minmax(0,1fr))"
                },
                gap: { xs: 0.45, sm: 0.7 }
              }, uiLayout.formSectionSx)}
            >
              <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                size="small"
                label="كود"
                value={model.code}
                disabled
               inputProps={{ dir: "ltr", style: { direction: "ltr", unicodeBidi: "isolate" } }} />

              <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                size="small"
                label="اسم الموظف"
                value={model.fullName}
                onChange={(e) =>
                  setField(
                    "fullName",
                    e.target.value
                  )
                }
              />

              <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                size="small"
                label="الاسم الحركي"
                placeholder="يظهر بين قوسين جنب الاسم"
                value={nickname}
                onChange={(e) => setNickname(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />

              <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                size="small"
                label="User Name"
                value={model.userName}
                onChange={(e) =>
                  setField(
                    "userName",
                    e.target.value
                  )
                }
                inputProps={{ dir: "ltr" }}
              />

              <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                size="small"
                label="Password"
                value={model.password}
                onChange={(e) =>
                  setField(
                    "password",
                    e.target.value
                  )
                }
                inputProps={{ dir: "ltr" }}
              />

              <FormControl sx={uiLayout.formFieldSx} size="small" fullWidth>
                <InputLabel id="user-job-label">
                  الوظيفة
                </InputLabel>

                <Select
                  labelId="user-job-label"
                  label="الوظيفة"
                  value={
                    Number.isInteger(Number(model.userJop)) &&
                    Number(model.userJop) >= 0
                      ? Number(model.userJop)
                      : ""
                  }
                  onChange={(e) =>
                    setField(
                      "userJop",
                      Number(e.target.value)
                    )
                  }
                  renderValue={(selectedLegacyCode) => {
                    const selected =
                      jobTitles.find(
                        (job) =>
                          Number(job.legacyJobCode) ===
                          Number(selectedLegacyCode)
                      );

                    return (
                      selected?.jobTitleName ||
                      `وظيفة قديمة رقم ${selectedLegacyCode}`
                    );
                  }}
                  disabled={jobTitlesLoading}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: { xs: 260, sm: 360 },
                        "& .MuiMenuItem-root": {
                          minHeight: { xs: 32, sm: 38 },
                          fontSize: { xs: 11.5, sm: 13.5 },
                          py: { xs: 0.35, sm: 0.65 }
                        }
                      }
                    }
                  }}
                >
                  {jobTitles.map((job) => {
                    const legacyCode =
                      Number(job.legacyJobCode);

                    const hiddenLegacy =
                      job.showInUserSelection === false &&
                      legacyCode !== Number(model.userJop);

                    return (
                      <MenuItem
                        key={
                          job.jobTitleGuid ||
                          `legacy-${legacyCode}`
                        }
                        value={legacyCode}
                        disabled={hiddenLegacy}
                      >
                        {job.jobTitleName}
                        {hiddenLegacy
                          ? " — غير متاح للاختيار"
                          : ""}
                      </MenuItem>
                    );
                  })}

                  {!jobTitlesLoading &&
                    !jobTitles.length && (
                      <MenuItem disabled>
                        {jobTitlesError ||
                          "لا توجد وظائف متاحة"}
                      </MenuItem>
                    )}
                </Select>
              </FormControl>

              <TextField
                sx={uiLayout.withUiSx(lookupFieldSx, uiLayout.formFieldSx)}
                InputLabelProps={{ shrink: true }}
                size="small"
                label="الفرع التابع له"
                value={model.branchForWorkName}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          openLookup(
                            "branchForWork",
                            "قائمة الفروع"
                          )
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                sx={uiLayout.withUiSx(lookupFieldSx, uiLayout.formFieldSx)}
                InputLabelProps={{ shrink: true }}
                size="small"
                label="القسم التابع له"
                value={model.departmentName}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          openLookup(
                            "department",
                            "قائمة الأقسام"
                          )
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                sx={uiLayout.withUiSx(lookupFieldSx, uiLayout.formFieldSx)}
                InputLabelProps={{ shrink: true }}
                size="small"
                label="مندوب البيع"
                value={model.sellerName}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          openLookup(
                            "seller",
                            "قائمة مندوبي البيع"
                          )
                        }
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Box>

            <Divider sx={{ my: { xs: 1, sm: 1.5 } }} />

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2,minmax(0,1fr))",
                  sm: "repeat(3,minmax(0,1fr))",
                  lg: "repeat(4,minmax(0,1fr))"
                },
                gap: { xs: 0.1, sm: 0.35 },
                "& .MuiFormControlLabel-root": {
                  m: 0,
                  minWidth: 0
                },
                "& .MuiFormControlLabel-label": {
                  fontSize: { xs: 12, sm: 12.5 },
                  lineHeight: 1.15
                },
                "& .MuiCheckbox-root": {
                  p: { xs: 0.5, sm: 1 }
                }
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.isUse}
                    onChange={(e) =>
                      setField(
                        "isUse",
                        e.target.checked
                      )
                    }
                  />
                }
                label="نشط"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkAmount}
                    onChange={(e) =>
                      setField(
                        "chkAmount",
                        e.target.checked
                      )
                    }
                  />
                }
                label="إدخال مبالغ صفرية"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkOtherFess}
                    onChange={(e) =>
                      setField(
                        "chkOtherFess",
                        e.target.checked
                      )
                    }
                  />
                }
                label="إضافة رسوم للطالب في عدم وجود ملف تدريبي"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkAccept}
                    onChange={(e) =>
                      setField(
                        "chkAccept",
                        e.target.checked
                      )
                    }
                  />
                }
                label="قبول طالب من البرنامج القديم"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkAllowCompany}
                    disabled
                  />
                }
                label="السماح للشركات"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkTrainer}
                    onChange={(e) => {
                      const checked =
                        e.target.checked;

                      setModel((current) => ({
                        ...current,
                        chkTrainer: checked,
                        trainerGuid:
                          checked
                            ? current.trainerGuid
                            : ZERO_GUID,
                        trainerName:
                          checked
                            ? current.trainerName
                            : ""
                      }));
                    }}
                  />
                }
                label="الموظف يعمل كمدرب"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={model.chkBranch}
                    onChange={(e) => {
                      const checked = e.target.checked;

                      setModel((current) => ({
                        ...current,
                        chkBranch: checked,

                        // لا يوجد اختيار "فرع تقارير" منفصل في الواجهة.
                        // الفروع المعتمدة فعليًا هي القائمة المختارة أسفل الشاشة.
                        branchGuid: ZERO_GUID,
                        branchName: ""
                      }));
                    }}
                  />
                }
                label="فروع مخصصة للتقارير"
              />
            </Box>

            {model.chkTrainer && (
              <Box
                sx={uiLayout.withUiSx({
                  mt: 1.5,
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    md: "repeat(2,minmax(0,1fr))"
                  },
                  gap: 1
                }, uiLayout.formSectionSx)}
              >
                {model.chkTrainer && (
                  <TextField sx={uiLayout.formFieldSx} InputLabelProps={{ shrink: true }}
                    size="small"
                    label="المدرب"
                    value={model.trainerName}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              openLookup(
                                "trainer",
                                "قائمة المدربين"
                              )
                            }
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                )}

                {/* "فرع التقارير" (User_Info.BranchGuid) اتشال: مش مستخدم في أي مكان
                    (في الديسكتوب متعلّق ومحدش ليه قيمة فيه). علامة "فروع مخصصة للتقارير"
                    فاضلة وبتقصر الفروع على "الفروع المسموح بها للمستخدم" تحت. */}
              </Box>
            )}

            <Divider sx={{ my: { xs: 1, sm: 1.5 } }} />

            <Typography variant="h6" sx={{ fontWeight: 900, mb: { xs: 0.5, sm: 0.75 } }}
            >
              الفروع المسموح بها للمستخدم
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  md: "1fr 1fr"
                },
                gap: { xs: 0.75, sm: 1 }
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderColor: border
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 900,
                    mb: 1
                  }}
                >
                  قائمة الفروع
                </Typography>

                <Box
                  sx={{
                    maxHeight: { xs: 165, sm: 230, md: 280 },
                    overflow: "auto",
                    display: "grid",
                    gap: 0.5
                  }}
                >
                  {unselectedBranches.map(
                    (branch) => (
                      <Button
                        key={branch.guid}
                        variant="text"
                        onClick={() =>
                          addAllowedBranch(branch)
                        }
                        sx={uiLayout.withUiSx({
                          justifyContent: "space-between",
                          color: "text.primary",
                          minHeight: { xs: 28, sm: 34 },
                          py: { xs: 0.15, sm: 0.4 },
                          px: { xs: 0.35, sm: 0.8 },
                          fontSize: { xs: 12, sm: 13 }
                        }, uiLayout.buttonSx)}
                      >
                        <span>{branch.name}</span>
                        <AddIcon fontSize="small" />
                      </Button>
                    )
                  )}
                </Box>
              </Paper>

              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderColor: border
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 900,
                    mb: 1
                  }}
                >
                  الفروع المختارة
                </Typography>

                <Box
                  sx={{
                    maxHeight: { xs: 165, sm: 230, md: 280 },
                    overflow: "auto",
                    display: "grid",
                    gap: 0.5
                  }}
                >
                  {selectedBranches.map(
                    (branch) => (
                      <Button
                        key={branch.guid}
                        color="error"
                        variant="text"
                        onClick={() =>
                          removeAllowedBranch(
                            branch.guid
                          )
                        }
                        sx={uiLayout.withUiSx({
                          justifyContent: "space-between",
                          minHeight: { xs: 28, sm: 34 },
                          py: { xs: 0.15, sm: 0.4 },
                          px: { xs: 0.35, sm: 0.8 },
                          fontSize: { xs: 12, sm: 13 }
                        }, uiLayout.buttonSx)}
                      >
                        <span>{branch.name}</span>
                        <CloseIcon fontSize="small" />
                      </Button>
                    )
                  )}

                  {!selectedBranches.length && (
                    <Alert severity="info">
                      لم يتم اختيار فروع.
                    </Alert>
                  )}
                </Box>
              </Paper>
            </Box>
          </Box>
        )}

        {tab === 1 && (
          <Box sx={{ p: { xs: 0.75, sm: 1.25, md: 1.5 } }}>
            <Stack
              direction="row"
              spacing={0.5}
              flexWrap="wrap"
              useFlexGap
              sx={uiLayout.withUiSx({
                mb: { xs: 0.7, sm: 1 },
                "& .MuiButton-root": {
                  flex: { xs: "1 1 45%", sm: "0 0 auto" },
                  fontSize: { xs: 12, sm: 13 }
                }
              }, uiLayout.actionBarSx)}
            >
              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                startIcon={<SelectAllIcon />}
                onClick={fullControl}
              >
                حقوق كاملة
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                color="error"
                startIcon={<DeleteSweepIcon />}
                onClick={deleteAllPermissions}
              >
                حذف الكل
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="contained"
                startIcon={<Inventory2Icon />}
                onClick={() => setPackagesMode("apply")}
              >
                تطبيق باكدج
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                startIcon={<ContentCopyIcon />}
                onClick={() => setPackagesMode("copy")}
              >
                نسخ من مستخدم
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                startIcon={<SettingsSuggestIcon />}
                onClick={() => setPackagesMode("manage")}
              >
                إدارة الباكدجات
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                startIcon={<GroupsIcon />}
                onClick={() => setBulkOpen(true)}
              >
                صلاحيات لمجموعة مستخدمين
              </Button>

              <Button sx={uiLayout.buttonSx}
                variant="outlined"
                color="error"
                startIcon={<DesktopAccessDisabledIcon />}
                onClick={() => setDesktopAccessOpen(true)}
              >
                منع الديسكتوب
              </Button>
            </Stack>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  lg: "260px minmax(0,1fr)"
                },
                gap: { xs: 0.75, sm: 1 }
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderColor: border,
                  overflow: "hidden"
                }}
              >
                <Box
                  className="dark-section-header"
                  sx={(theme) => ({
                    p: 1,
                    bgcolor: theme.palette.mode === "dark"
                      ? (theme.palette.surfaces?.section || "#172b22")
                      : "#eef7f3"
                  })}
                >
                  <Typography sx={{ fontWeight: 900 }}>
                    القوائم الرئيسية
                  </Typography>
                </Box>

                <Box
                  sx={{
                    maxHeight: { xs: 260, sm: 340, md: 420 },
                    overflow: "auto"
                  }}
                >
                  {menus.map((item, index) => (
                    <FormControlLabel
                      key={item.guid}
                      sx={{
                        width: "100%",
                        m: 0,
                        px: 1,
                        borderBottom:
                          `1px solid ${border}`
                      }}
                      control={
                        <Checkbox
                          checked={Boolean(item.view)}
                          onChange={(e) => {
                            const checked =
                              e.target.checked;

                            setMenus((current) => {
                              const next =
                                current.slice();

                              next[index] = {
                                ...next[index],
                                view: checked
                              };

                              return next;
                            });
                          }}
                        />
                      }
                      label={item.name}
                    />
                  ))}
                </Box>
              </Paper>

              <Paper
                variant="outlined"
                sx={{
                  borderColor: border,
                  overflow: "hidden"
                }}
              >
                <Box
                  className="dark-section-header"
                  sx={(theme) => ({
                    p: 1,
                    bgcolor: theme.palette.mode === "dark"
                      ? (theme.palette.surfaces?.section || "#172b22")
                      : "#eef7f3",
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "stretch", sm: "center" },
                    justifyContent: "space-between",
                    gap: 0.75
                  })}
                >
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 900 }}>
                      كل الشاشات والصلاحيات
                    </Typography>
                  </Box>

                  <Autocomplete
                    size="small"
                    options={availableForms}
                    getOptionLabel={(o) =>
                      o?.name || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      norm(option?.guid) ===
                      norm(value?.guid)
                    }
                    filterOptions={(options, state) => {
                      const q = norm(state.inputValue);

                      if (!q) return options;

                      return options.filter((option) =>
                        [
                          option?.name,
                          option?.webItemKey,
                          option?.webRoute,
                          option?.code,
                          formPlatformLabel(option)
                        ].some((value) =>
                          norm(value).includes(q)
                        )
                      );
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.guid}>
                        <Box sx={{ minWidth: 0, width: "100%" }}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.6}
                          >
                            <Chip
                              size="small"
                              variant="outlined"
                              label={formPlatformLabel(option)}
                              sx={(theme) => ({
                                height: 20,
                                fontSize: 10,
                                fontWeight: 900,
                                backgroundColor:
                                  theme.palette.mode === "dark"
                                    ? "transparent"
                                    : formPlatform(option) === "web"
                                      ? "#e8f5ee"
                                      : "#f4f5f6",
                                color:
                                  theme.palette.mode === "dark"
                                    ? DARK_TEXT
                                    : formPlatform(option) === "web"
                                      ? primary
                                      : "#5b6770",
                                borderColor:
                                  theme.palette.mode === "dark"
                                    ? DARK_BORDER
                                    : formPlatform(option) === "web"
                                      ? primary
                                      : "#9aa5ad"
                              })}
                            />
                            <Typography
                              sx={{
                                fontSize: 12.5,
                                fontWeight: 850
                              }}
                            >
                              {option.name}
                            </Typography>
                          </Stack>
                          <Typography
                            sx={{
                              mt: 0.15,
                              fontSize: 10.5,
                              color: "text.secondary",
                              direction: "ltr",
                              textAlign: "right",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {formPlatform(option) === "web" ? (option.webRoute || option.webItemKey || "شاشة ويب") : `Code: ${option.code || "-"}`}
                          </Typography>
                        </Box>
                      </li>
                    )}
                    onChange={(_, value) => {
                      if (value)
                        addFormToPermissions(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={uiLayout.withUiSx({
                          "& .MuiAutocomplete-endAdornment": {
                            left: 6,
                            right: "auto"
                          },
                          "& .MuiAutocomplete-inputRoot": {
                            paddingLeft: "56px !important",
                            paddingRight: "10px !important"
                          }
                        }, uiLayout.formFieldSx)}
                        InputLabelProps={{ shrink: true }}
                        placeholder="ابحث في كل الشاشات..."
                        InputProps={{
                          ...params.InputProps
                        }}
                      />
                    )}
                    sx={{
                      width: { xs: "100%", sm: 340 },
                      minWidth: 0
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    overflow: "auto",
                    maxHeight: { xs: 360, sm: 340, md: 420 }
                  }}
                >
                  {/* MOBILE: cards compact, no horizontal scroll */}
                  <Box
                    sx={{
                      display: { xs: "grid", sm: "none" },
                      gap: 0.5,
                      p: 0.5
                    }}
                  >
                    {isMobile && permissions.map((p, index) => (
                      <PermissionCard key={p.guid} p={p} index={index} onChange={updatePermission} />
                    ))}

                    {!permissions.length && (
                      <Alert
                        severity="info"
                        sx={{
                          py: 0.35,
                          fontSize: 12
                        }}
                      >
                        لم تتم إضافة شاشات للصلاحيات.
                      </Alert>
                    )}
                  </Box>

                  {/* TABLET / DESKTOP */}
                  <Box
                    sx={{
                      display: { xs: "none", sm: "block" },
                      minWidth: 760
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns:
                          "minmax(230px,1fr) repeat(6,70px)",
                        bgcolor: theme.palette.mode === "dark"
                          ? (theme.palette.surfaces?.section || "#172b22")
                          : "#f7faf8",
                        borderBottom:
                          `1px solid ${theme.palette.mode === "dark" ? DARK_BORDER : border}`,
                        fontWeight: 900
                      }}
                    >
                      {[
                        "اسم الشاشة / النوع",
                        "جديد",
                        "تعديل",
                        "حذف/إلغاء",
                        "طباعة",
                        "بحث",
                        "عرض"
                      ].map((h) => (
                        <Box
                          key={h}
                          sx={{
                            p: 1,
                            textAlign: "center"
                          }}
                        >
                          {h}
                        </Box>
                      ))}
                    </Box>

                    {!isMobile && permissions.map((p, index) => (
                      <PermissionRow key={p.guid} p={p} index={index} onChange={updatePermission} />
                    ))}
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Box>
        )}

        {isEdit && (
          <Box hidden={tab !== 2}>
          <UserDocumentsTab
            ref={documentsTabRef}
            key={model.guid}
            apiBaseUrl={API_BASE_URL}
            actorGuid={getUserGuid()}
            targetUserGuid={model.guid}
            targetUserName={model.fullName}
            border={border}
            primary={primary}
          />
          </Box>
        )}
      </Paper>

      <LookupDialog
        open={lookup.open}
        title={lookup.title}
        rows={lookup.rows}
        loading={lookup.loading}
        error={lookup.error}
        search={lookup.search}
        setSearch={(value) =>
          setLookup((current) => ({
            ...current,
            search: value
          }))
        }
        onClose={closeLookup}
        onPick={pickLookup}
        columns={lookupColumns}
      />

      <PermissionPackagesDialog
        mode={packagesMode}
        onClose={() => setPackagesMode("")}
        apiBaseUrl={API_BASE_URL}
        userGuid={userGuid}
        menus={menus}
        forms={forms}
        currentState={{ menus, permissions }}
        currentUserName={model.fullName || (isEdit ? model.userName : "المستخدم الجديد")}
        onApply={applyPermissionSet}
      />

      <BulkPermissionsDialog
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        apiBaseUrl={API_BASE_URL}
        userGuid={userGuid}
        menus={menus}
        forms={forms}
        onDone={({ allUsers, userGuids }) => {
          // لو المستخدم المفتوح في الشاشة اتعدّل، نعيد تحميله علشان الحفظ العادي ما يرجّعش صلاحياته القديمة.
          const openGuid = norm(model.guid);
          if (isEdit && model.code && (allUsers || (userGuids || []).includes(openGuid))) {
            loadUser(model.code);
          }
        }}
      />

      <DesktopAccessDialog
        open={desktopAccessOpen}
        onClose={() => setDesktopAccessOpen(false)}
        apiBaseUrl={API_BASE_URL}
        userGuid={userGuid}
      />
    </PageContainer>
  );

  return (
    <NavigationShell variant="standard" mobileOpen={mobileSidebarOpen} onMobileClose={() =>
            setMobileSidebarOpen(false)
          }>
      <GlobalStyles styles={darkUserManagementStyles} />
      <Box
        className="user-management-page"
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: theme.palette.mode === 'dark' ? theme.palette.background.default : soft
      }}
    >
      

      

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          ...navigationContentSx
        }}
      >
        {content}
      </Box>
    </Box>
    </NavigationShell>
  );
}
